// test2425
(2425 && 0);
